export default "__VITE_ASSET__DIL9w9qt__"